export default __webpack_public_path__ + "static/media/BTC 100_3 copy 1.27beb6ff.svg";